import React from 'react';
import { Row, Col } from 'react-bootstrap';

const fmt = (n) => `PKR ${(n || 0).toLocaleString()}`;
const AdmHotelPaymentStats = ({ stats = {} }) => {

  const cards = [
    { title: 'Total Revenue',       value: fmt(stats.totalRevenue),     icon: 'bi-cash-stack',            color: 'adm-bkd-stat-green', desc: 'Total booking amount' },
    { title: 'Platform Commission', value: fmt(stats.totalCommission),  icon: 'bi-percent',               color: 'adm-bkd-stat-blue',  desc: '15% platform fee'     },
    { title: 'Pending Payouts',     value: fmt(stats.pendingPayouts),   icon: 'bi-hourglass-split',       color: 'adm-bkd-stat-amber', desc: 'Due to vendors'       },
    { title: 'Completed Payouts',   value: fmt(stats.completedPayouts), icon: 'bi-check-circle',          color: 'adm-bkd-stat-teal',  desc: 'Transferred'          },
    { title: 'Refunded Amount',     value: fmt(stats.refundedAmount),   icon: 'bi-arrow-counterclockwise', color: 'adm-bkd-stat-red',  desc: 'Total refunds'        },
  ];

  return (
    <div className="adm-bkd-stats-row">
      <Row className="g-3">
        {cards.map((card, i) => (
          <Col key={i} xs={6} md={4} lg={2}>
            <div className={`adm-bkd-stat-card ${card.color}`}>
              <div className="adm-bkd-stat-icon-wrap">
                <i className={`bi ${card.icon}`} />
              </div>
              <div className="adm-bkd-stat-info">
                <span className="adm-bkd-stat-label">{card.title}</span>
                <span className="adm-bkd-stat-value">{card.value}</span>
                {card.desc && <span className="adm-bkd-stat-desc">{card.desc}</span>}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AdmHotelPaymentStats;